/**
 * Display helpers for connector gender and XLR audio role hints.
 */

export function getXlrAudioRoleHint(connector) {
  if (!connector) return null;
  const isXlr3Pin =
    (connector.family?.includes('XLR 3-pin') || connector.type === 'XLR') &&
    (connector.poles === undefined || connector.poles === 3);
  if (!isXlr3Pin) return null;

  const gender = connector.gender?.toLowerCase();
  if (gender === 'male') return 'typically output (send)';
  if (gender === 'female') return 'typically input (receive)';
  return null;
}

export function formatGenderWithXlrHint(connector) {
  const gender = connector?.gender;
  if (!gender) return 'Unknown';

  const capitalized = gender.charAt(0).toUpperCase() + gender.slice(1);
  const hint = getXlrAudioRoleHint(connector);
  return hint ? `${capitalized} — ${hint}` : capitalized;
}

/**
 * Open a blank tab during a user click so async cart work can navigate it later
 * without popup blockers.
 */
export function openCartTabDuringGesture() {
  try {
    return window.open('about:blank', '_blank');
  } catch {
    return null;
  }
}

/**
 * Navigate a pre-opened cart tab. Returns true when navigation likely succeeded.
 */
export function navigateCartTab(cartWindow, redirectUrl) {
  if (!redirectUrl) return false;

  if (cartWindow && !cartWindow.closed) {
    try {
      cartWindow.location.href = redirectUrl;
      return true;
    } catch {
      // Fall through to blocked detection
    }
  }

  return false;
}

export function closeCartTab(cartWindow) {
  if (cartWindow && !cartWindow.closed) {
    try {
      cartWindow.close();
    } catch {
      // Ignore close failures
    }
  }
}
